import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { updateLocalStorageItem } from "@/utils/localStorage";

const authentication_url = process.env.VUE_APP_XMARTSHELF_AUTHENTICATION;

const state = {
  session: null,
  userData: null,
  email: null,
  user_id: null,
  twoFactorSession: null
};
const getters = {
  getSession(state) {
    return state.session;
  },
  getSessionToken(state) {
    return state.session ? state.session.jwt : null;
  },
  getUserData(state) {
    return state.userData;
  },
  getUserId(state) {
    if (state.user_id) {
      return state.user_id;
    } else {
      return state.userData.id;
    }
  },
  getUserEmail(state) {
    return state.email;
  },
  getTwoFactorSession(state) {
    return state.twoFactorSession;
  }
};
const mutations = {
  setSession(state, payload) {
    state.session = payload;
    updateLocalStorageItem("xmartshelf_admin", { session: payload });
  },
  setUserData(state, payload) {
    state.userData = payload;
  },
  setUserId(state, payload) {
    state.user_id = payload;
  },
  setUserEmail(state, payload) {
    state.email = payload;
  },
  setTwoFactorSession(state, payload) {
    state.twoFactorSession = payload;
  }
};
const actions = {
  loginSession({ commit }, { username, password }) {
    return new Promise((resolve) => {
      axios
        .post(
          `${authentication_url}/admin/login`,
          {
            user: username,
            password: password
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then((response) => {
          const session = response.data.sessionData;
          const firstAccess = session.firstAccess;

          if (!firstAccess) {
            commit("setSession", {
              session_id: session.session_id,
              jwt: session.jwt
            });
          }

          const userData = jwtDecode(session.jwt);

          commit("setUserData", userData);

          resolve({
            success: true,
            message: response.data.message,
            first_access: firstAccess
          });
        })
        .catch((error) => {
          console.error(error);
          resolve({
            success: false,
            message: "Usuário ou senha inválida."
          });
        });
    });
  },
  async logoutSession({ commit, dispatch }) {
    //await dispatch("sendLogout");
    return new Promise((resolve) => {
      commit("setSession", null);
      commit("setUserData", null);
      commit("setTwoFactorSession", null);
      commit("setStore", null);
      commit("setSale", null);
      commit("setSaleId", null);
      dispatch("cleanRules");
      resolve();
    });
  },
  sendLogout({ getters }) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${authentication_url}/admin/auth/logout`,
          { session_id: getters.getSession.session_id },
          {
            headers: {
              Authorization: `Bearer ${getters.getSessionToken}`,
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then(() => {
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  },
  validateToken({ getters }, { token }) {
    return new Promise((resolve) => {
      axios
        .post(
          `${authentication_url}/password/validate/token`,
          { token },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${getters.getTwoFactorSession}`
            }
          }
        )
        .then(() => {
          resolve({ success: true, message: "Token válido." });
        })
        .catch((error) => {
          resolve({ success: false, message: error.response.data.message });
          console.log(error);
        });
    });
  },
  changePassword({ getters }, { password }) {
    return new Promise((resolve) => {
      axios
        .post(
          `${authentication_url}/password/change_password`,
          {
            user_id: getters.getUserId,
            password,
            session_id: getters.getTwoFactorSession
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${getters.getTwoFactorSession}`
            }
          }
        )
        .then(() => {
          resolve({ success: true, message: "Senha alterada com sucesso." });
        })
        .catch((error) => {
          console.log(error);
          resolve({ success: false, message: "Erro ao alterar a senha." });
        });
    });
  },
  createSession({ commit, getters }) {
    return new Promise((resolve) => {
      commit("setTwoFactorSession", null);
      axios
        .post(
          `${authentication_url}/admin/login/firstSession`,
          {
            user_id: getters.getUserId
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then(() => {
          commit("setUserData", null);
          resolve({ success: true, message: "Sessão criada com sucesso." });
        })
        .catch((error) => {
          console.log(error);
          resolve({ success: false, message: "Erro ao criar a sessão." });
        });
    });
  },
  getSessionData({ commit, getters }) {
    return new Promise((resolve) => {
      const id = getters.getSession.session_id;
      const token = getters.getSessionToken;

      axios
        .get(`${authentication_url}/session/session_data/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        })
        .then((response) => {
          const session = response.data.sessionData;
          const userData = jwtDecode(session.jwt);

          commit("setUserData", userData);
          resolve({
            success: true,
            message: "Dados de sessão carregado com sucesso."
          });
        })
        .catch((error) => {
          console.error(error);
          commit("setSession", null);
          resolve({ success: false, message: "Sessão expirada." });
        });
    });
  },
  requestToken({ commit, getters }, { username }) {
    return new Promise((resolve) => {
      axios
        .post(
          `${authentication_url}/password/recovery`,
          {
            email: username,
            session_id: getters.getTwoFactorSession
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then((response) => {
          if (response.data.session_id) {
            commit("setTwoFactorSession", response.data.session_id);
            commit("setUserId", response.data.user_id);
            resolve({ success: true, message: response.data.message });
          } else {
            resolve({ success: false, message: response.data.message });
          }
        })
        .catch((error) => {
          console.log(error);
          resolve({ success: false, message: "Erro ao solicita operação" });
        });
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
